import jquery = require('jquery');
import 'slick-carousel/slick/slick';

import { loadWistiaAPI, ensureWistiaVideoDivExists } from './wistia';


function enableSlickCarousel() {
    return jquery('.customers-carousel')
        .removeClass('loading')
        .slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
        });
}

function setLoading(element, enable) {
    element.find('.customers-carousel__video__play')[enable ? 'addClass' : 'removeClass']('loading');
}

function loadWistiaOnVideoClick() {
    window['_wq'] = window['_wq'] || [];

    jquery('.customers-carousel a[data-wistia-videoid]').each(function () {
        var jqLink = jquery(this);
        var videoId = jqLink.data('wistia-videoid');

        setLoading(jqLink, false);

        jqLink.on('click', function (e) {
            e.preventDefault();
            setLoading(jqLink, true);
            ensureWistiaVideoDivExists(
                videoId,
                'popover=true popoverContent=html',
                videoEl => videoEl.insertAfter('.section--happy-customers__logos')
            );

            loadWistiaAPI().then(() => {
                window['_wq'].push({
                    id: videoId,
                    onReady: (video) => {
                        video.bind('popoverhide', () => video.pause());
                        video.popover.show();
                        video.play();
                        setTimeout(() => setLoading(jqLink, false), 100);
                    }
                })
            })
        });
    });
}

jquery(() => {
    const thumbs = jquery('.section--happy-customers__logos .section--happy-customers__logos__item');
    const carousel = enableSlickCarousel().on('beforeChange', (ev, slick, currentSlide, nextSlide) => {
        thumbs.removeClass('active');
        thumbs.eq(nextSlide).addClass('active');
    });

    thumbs.on('click', (ev) => {
        ev.preventDefault();
        const thumb = ev.currentTarget;

        const index = Array.prototype.indexOf.call(thumb.parentElement.children, thumb);
        carousel.slick('slickGoTo', index);
    });

    loadWistiaOnVideoClick();
});
